import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/sales')({
  // Deep-link contract: ?range= & ?from= & ?to= & ?q= & ?channel= & ?donor=
  // preset the sales filters.
  validateSearch: (search) => ({
    range: typeof search.range === 'string' ? search.range : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    channel: typeof search.channel === 'string' ? search.channel : undefined,
    donor: typeof search.donor === 'string' ? search.donor : undefined,
  }),
});
